if (!customElements.get('cart-extra-data-fields')) {
	class CartExtraDataFields extends HTMLElement {
		constructor() {
			super();

			// Prevent multiple initializations
			if (this._initialized) {
				console.log('=== ALREADY INITIALIZED, SKIPPING ===');
				return;
			}
			this._initialized = true;

			this.checkoutButton = document.querySelector('button[name="checkout"]');
			this.requiredFields = this.querySelectorAll('[required]');
			this.cvrEanField = this.querySelector('[name="attributes\\[cvr_ean\\]"]');
			this.customerTypeFields = this.querySelectorAll('input[name="attributes\\[customer_type\\]"]');

			this.validateFields = this.validateFields.bind(this);
			this.handleCvrEanInput = this.handleCvrEanInput.bind(this);
			this.saveFieldToCart = this.saveFieldToCart.bind(this);
		}

		connectedCallback() {
			this.init();
		}

		init() {
			// Extra safety check to prevent multiple initializations
			if (this._initCalled) {
				console.log('=== INIT ALREADY CALLED, SKIPPING ===');
				return;
			}
			this._initCalled = true;

			this.validateFields();
			this.requiredFields.forEach(field => {
				field.addEventListener('change', this.validateFields);
				field.addEventListener('input', this.validateFields);
			});

			// Special handling for CVR/EAN field (not required, but needs validation)
			if (this.cvrEanField) {
				this.cvrEanField.addEventListener('input', this.handleCvrEanInput);
				this.cvrEanField.addEventListener('change', () => {
					this.validateCvrEanField();
					this.saveFieldToCart(this.cvrEanField);
				});
			}

			// Listen for autofill (for Chrome/Safari)
			window.addEventListener('animationstart', (e) => {
				if (e.animationName === 'onAutoFillStart') {
					this.validateFields();
					this.validateCvrEanField();
					if (this.cvrEanField) {
						this.saveFieldToCart(this.cvrEanField);
					}
				}
			});

      // removed due to causing other bugs in cart as this runs update events all the time
			// setTimeout(() => {
			// 	this.validateFields();
			// 	this.validateCvrEanField();
			// 	if (this.cvrEanField) {
			// 		this.saveFieldToCart(this.cvrEanField);
			// 	}
			// }, 500);

			function debounce(func, wait) {
        console.log('debounce', func, wait);
				let timeout;
				return function executedFunction(...args) {
					const later = () => {
					clearTimeout(timeout);
					func(...args);
					};
					clearTimeout(timeout);
					timeout = setTimeout(later, wait);
				};
			}

			this.requiredFields.forEach(field => {
				field.addEventListener('change', debounce(() => this.saveFieldToCart(field), 300));
			});

			this.customerTypeFields.forEach(field => {
				console.log('Adding change listener to customer type field:', field.name, field.type);
				field.addEventListener('change', function(e) {
					console.log('CUSTOMER TYPE CHANGE event fired on:', e.target.name, e.target.type, e);
					
					Array.from(e.target.parentElement.parentElement.children).forEach(child => {
						console.log("child", child);
						child.classList.remove('is-active');						
					});
					
					e.target.parentElement.classList.add('is-active');
					e.target.closest('fieldset[data-checked-customer-type]').setAttribute('data-checked-customer-type', e.target.value);
				});

			});
		}

		handleCvrEanInput(event) {
			this.validateCvrEanField();

			clearTimeout(this.cvrEanSaveTimeout);
			this.cvrEanSaveTimeout = setTimeout(() => {
				this.saveFieldToCart(this.cvrEanField);
			}, 300);
		}

		validateCvrEanField() {
			if (!this.cvrEanField) return;

			const value = this.cvrEanField.value.trim();
			const isValid = this.isValidCVRorEAN(value);

			this.cvrEanField.classList.remove('is-valid', 'is-invalid');

			if (value && !isValid) {
				this.cvrEanField.classList.add('is-invalid');
			} else if (value && isValid) {
				this.cvrEanField.classList.add('is-valid');
			}

			this.updateCheckoutButton();
		}

		isValidCVRorEAN(value) {
			if (!value) return true; // Empty is considered valid (not required)

			// Remove spaces and dashes
			const cleanValue = value.replace(/[\s-]/g, '');

			// Check if it's a valid CVR (8 digits) or EAN (13 digits)
			return /^\d{8}$/.test(cleanValue) || /^\d{13}$/.test(cleanValue);
		}

		updateCheckoutButton() {
			if (!this.checkoutButton) return;

			// Check if any required fields are invalid
			const requiredFieldsValid = Array.from(this.requiredFields).every(field =>
				field.value && field.validity.valid
			);

			// Check if CVR/EAN field is valid (if it has a value)
			let cvrEanValid = true;
			if (this.cvrEanField && this.cvrEanField.value.trim()) {
				cvrEanValid = this.isValidCVRorEAN(this.cvrEanField.value.trim());
			}

			this.checkoutButton.disabled = !(requiredFieldsValid && cvrEanValid);
		}

		validateFields() {
			if (!this.checkoutButton) return;
			this.updateCheckoutButton();
		}

		saveFieldToCart(field) {
			if (!field) return;

			const fieldName = field.getAttribute('name');
			const fieldValue = field.value;

			const body = JSON.stringify({
				attributes: {
					[fieldName]: fieldValue
				}
			});
      
			fetch(`${themeVariables.routes.cartUpdateUrl}`, {
				...(function (type = 'json') {
					return {
					  method: 'POST',
					  headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
					};
				  }()),
				body
			}).catch(error => {
				console.error('Error saving field to cart:', error);
			});
		}
	}

	customElements.define('cart-extra-data-fields', CartExtraDataFields);
}
